import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props'
import { createNamespace } from 'vant/lib/utils'
import { inherit } from 'vant/lib/utils/functional'
// import Button from '../../button'; // Types
import {
    Button,
} from 'vant'
var _createNamespace = createNamespace('sku-actions')
var createComponent = _createNamespace[0]
var bem = _createNamespace[1]
var t = _createNamespace[2]

function SkuActions (h, props, slots, ctx) {
    var createEmitter = function createEmitter (name) {
        return function () {
            props.skuEventBus.$emit(name)
        }
    }

    return h('div', _mergeJSXProps([{
        'class': bem()
    }, inherit(ctx)]), [props.showAddCartBtn && h(Button, {
        'attrs': {
            'size': 'large',
            'type': 'warning',
            'text': props.addCartText || t('addCart')
        },
        'on': {
            'click': createEmitter('sku:addCart')
        }
    }), h(Button, {
        'attrs': {
            'size': 'large',
            'type': 'danger',
            'text': props.buyText || t('buy')
        },
        'on': {
            'click': createEmitter('sku:buy')
        }
    })])
}

SkuActions.props = {
    buyText: String,
    addCartText: String,
    skuEventBus: Object,
    showAddCartBtn: Boolean
}
export default createComponent(SkuActions)
